import { render, staticRenderFns } from "./joinItem.vue?vue&type=template&id=7cbd8802&scoped=true&"
import script from "./joinItem.vue?vue&type=script&lang=js&"
export * from "./joinItem.vue?vue&type=script&lang=js&"
import style0 from "./joinItem.vue?vue&type=style&index=0&id=7cbd8802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbd8802",
  null
  
)

export default component.exports